// extracted by mini-css-extract-plugin
module.exports = {"button-arrow":"styles_button-arrow__FF6j0","inner":"styles_inner__Ybwhd","expand":"styles_expand__Cx9pe"};